import React, { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import ReactSelect from 'react-select';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import Pagination from '../Common/Pagination';
import { toast } from 'react-toastify';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import moment from "moment-jalali";

const Participated = () => {

    let userData = localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')).roleId : {};

    
    const { readData: getReports } = useEntityCrud('Report/participatedReport');
    const { readData: getGuilds } = useEntityCrud('Guild/GetAllGuilds');
    const { readData: getBusiness } = useEntityCrud('Business/GetAllBusiness');
    const { readData: getOpinions } = useEntityCrud('Opinions/getAll');

    const { addData: addAnswerComment } = useEntityCrud('Answer/updateAnswerMetaData');

    const [globalFilters, setGlobalFilters] = useState({});
    const [pages, setPages] = useState([]);
    const [mobile, setMobile] = useState('');
    const [guilds, setGuilds] = useState([]);
    const [guild, setGuild] = useState(0);
    const [opinion, setOpinion] = useState(0);
    const [opinions, setOpinions] = useState([]);
    const [businesses, setBusinesses] = useState([]);
    const [filteredBusinesses, setFilteredBusinesses] = useState([]);
    const [business, setBusiness] = useState(0);
    const [isParticipated, setIsParticipated] = useState('');
    const [hasComment, setHasComment] = useState('');
    const [comment, setComment] = useState('');
    const [commentAnswer, setCommentAnswer] = useState('');
    const [commentId, setCommentId] = useState('');
    const [isSearched, setIsSearched] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [count, setCount] = useState(0);
    const [rows, setRows] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [showItem, setShowItem] = useState(true);
    const [cityId, setCityId] = useState(0);
    const [provinceId, setProvinceId] = useState(0);
    const { readGetDataById: getProvinces } = useEntityCrud('Info/GetProvinces');
    const { readGetDataById: getCities } = useEntityCrud(`Info/GetCities?provinceId=${provinceId}`);
    const [provinces, setProvinces] = useState([]);
    const [cities, setCities] = useState([]);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [lastPage,setLastPage] = useState(0);

    const [branchId, setBranchId] = useState([]);
    const [branchs, setBranchs] = useState([]);
    const { readData: getBranchs } = useEntityCrud('Branch/GetAllBranchs');

    const [isAdvanced, setIsAdvanced] = useState(false);


    const [pageItems, setPageItems] = useState(0);

    useEffect(() => {
        showMore(pageItems)
    }, [pageItems])

    function convertToDate(date) {
        if (!date)
            return ""
        const dateString = moment(`${date.year}/${date.month}/${date.day}`, "jYYYY/jMM/jDD").format("jYYYY-jMM-jDD").split("-");
        return dateString[0] + dateString[1] + dateString[2]
    }


    useEffect(() => {
        getGuilds().then(({ data }) => {
            let guildsArr = [];
            if (data.status)
                data.result.map(item => {
                    if (item.isActive)
                        guildsArr.push({
                            label: item.title,
                            value: item.id
                        });
                })
            setGuilds(guildsArr);
        });
        getBusiness().then(({ data }) => {
            let businesses = [];
            if (data.status)
                data.result.map(item => {
                    // if (item.isActive) {
                        // if (!(businesses?.find(it => it.label === item.title))) {
                            businesses.push({
                                label: item.title,
                                guildId: item.guildId,
                                value: item.id
                            });
                        // }
                    // }
                })
            setBusinesses(businesses);
            if (userData === 3) {
                setBusiness(businesses.map(item => item)[0].value)
            }
        });


        getOpinions().then(({ data }) => {
            let opinionsArr = [];
            if (data.status)
                data.result.map(item => {
                    opinionsArr.push({
                        label: item.title,
                        guildId: item.guildId,
                        value: item.id
                    });
                })
            setOpinions(opinionsArr);
        })
        getBranchs().then(({ data }) => {
            let branchs = [];
            if (data.status)
                data.result.map(item => {
                    if (item.isActive)
                        branchs.push({
                            label: item.title,
                            value: item.id
                        });
                })
            setBranchs(branchs);
        })
        getProvinces().then(({ data }) => {
            let getProvinces = [];
            data.result.map(item => getProvinces.push({
                label: item.title,
                value: item.id
            }))
            setProvinces(getProvinces);
        })
    }, [])

    useEffect(() => {
        if(opinion){
            const selectedOpition = opinions.find(o => o.value == opinion)
            const filter = businesses.filter(b => b.guildId == selectedOpition.guildId)
            setFilteredBusinesses(filter)
        }
    },[opinion])


    useEffect(() => {
        if (provinceId != 0)
            getCities().then(({ data }) => {
                if (data.status) {
                    let getCities = [];
                    data.result.map(item => getCities.push({
                        label: item.title,
                        value: item.id
                    }))
                    setCities(getCities);
                }
            });
    }, [provinceId])


    useEffect(() => {
        const filters = {
            p_is_participated: isParticipated,
            p_mobile: mobile ? mobile.replace('-', '') : '',
            p_guild: guild,
            p_opinion_id: opinion,
            p_business: business,
            p_excelRequest: false,
            p_fromdate: convertToDate(fromDate),
            p_todate: convertToDate(toDate),
            branchId: branchId || 0,
            p_companyname: "",
            p_cityid: cityId || 0
        };

        if (hasComment === 1 || hasComment === 2)
            filters.p_hasComment = hasComment;
        else filters.p_hasComment = 0;

        setGlobalFilters(filters);
    }, [fromDate, toDate, isParticipated, hasComment, mobile, guild, business, branchId, cityId,opinion])


    const getReportsData = () => {

        setIsAdvanced(true);
        setLoading(true);
        setShowItem(false);

        const postedData = { ...globalFilters, p_offset: currentPage, p_limit: (pageItems === 0 ? 10 : pageItems) };
        getReports(postedData).then(({ data }) => {

            if (data.result) {

                setLoading(false)
                setShowItem(true);
                setRows(data.result.v_result);
                setCount(data.result.v_count[0].total_row);
                calcPages(data);
            } else
                setRows([]);
        }).finally(() => {
            setIsSearched(true);
        })
    }


    const calcPages = data => {
        let calcPages = data.result.v_count[0].total_row / (pageItems === 0 ? 10 : pageItems);
        calcPages = calcPages > 1 ? Math.ceil(calcPages) : 1
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++)
            pagesArray.push(i);
        setPages(pagesArray);
        setLastPage(pagesArray.length)
        setCurrentPage(1);
    }

    const changePage = (e, page) => {
        e.preventDefault();
        setCurrentPage(page);
        const postedData = {
            p_limit: (pageItems === 0 ? 10 : pageItems),
            p_offset: page
        };
        getReports({ ...globalFilters, ...postedData }).then(({ data }) => {
            if (data.result && data.result.v_result) {
                setRows(data.result.v_result);
            }
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const prevPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage - 1);
        const postedData = {
            p_limit: (pageItems === 0 ? 10 : pageItems),
            p_offset: currentPage - 1
        };
        getReports({ ...globalFilters, ...postedData }).then(({ data }) => {
            if (data.result && data.result.v_result) {
                setRows(data.result.v_result);
            }
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const nextPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage + 1);
        const postedData = {
            p_limit: (pageItems === 0 ? 10 : pageItems),
            p_offset: currentPage + 1
        };
        getReports({ ...globalFilters, ...postedData }).then(({ data }) => {
            if (data.result && data.result.v_result) {
                setRows(data.result.v_result);
            }
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }


    const downloadExcelFile = () => {
        setLoading(true);
        const filters = {};

        if (guild)
            filters.p_guild = guild;
        if (opinion)
            filters.p_opinion_id = opinion;
        if (business)
            filters.p_business = business;
        if (branchId)
            filters.branchId = branchId;


        setGlobalFilters(filters);
        const postedData = {
            ...globalFilters,
            p_limit: 0,
            p_offset: 0,
            "p_mobile": mobile ? mobile.replace('-', '') : '' || "",
            "p_is_participated": isParticipated
        };

        getReports(postedData).then(({ data }) => {
            setLoading(false);
            if (data.result) {
                let csvString = 'نام,کدملی,صنف,کسب و کار,شماره همراه,تاریخ ارسال پیامک,تاریخ ثبت نظر,مشاهده نظر\r';
                data.result.v_result?.map(row => {
                    csvString += `${row.full_name || "-"},${row.nationalcode || "-"},${row.guild_name || "-"},${row.business_name || "-"},${row.consumer_mobile || "-"},${row.register_date || "-"},${row.answerdate || "-"},${row.comments ? row.comments.replaceAll('\n', '') : "-"}\r`;
                });
                let universalBOM = '\uFEFF';
                let a = window.document.createElement('a');
                a.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(universalBOM + csvString));
                let fileName = 'report-export.csv';
                a.setAttribute('download', fileName);
                window.document.body.appendChild(a);
                a.click();
                window.document.body.removeChild(a);
            }
        }).finally(() => {
            setIsSearched(true);
        })
    }

    const resetAdvancedSearch = e => {
        e.preventDefault();
        setIsAdvanced(false);

        setOpinion(0)
        setBusiness(0)
        setGuild(0)
        setBranchId([])
        setMobile("")
        setIsParticipated('')
        setHasComment('')
        setRows([]);
        setIsSearched(false);
        setCityId(0);
        setProvinceId(0)
        setFromDate("")
        setToDate("")

        const postedData = { p_offset: 0, p_limit: (pageItems === 0 ? 10 : pageItems) };
        getReports(postedData).then(({ data }) => {
            if (data.result) {
                setRows(data.result.v_result);
                setCount(data.result.v_count[0].total_row);
                calcPages(data);
            } else
                setRows([]);
        })
    }


    const showMore = (val) => {

        const postData = {
            p_offset: currentPage,
            p_limit: val,
            ...globalFilters
        }

        getReports(postData).then(({ data }) => {
            if (data.result) {
                setLoading(false)
                setShowItem(true);
                setRows(data.result.v_result);
                setCount(data.result.v_count[0].total_row);
                calcPages(data);
            } else
                setRows([]);
        })
    }


    const saveAnswer = () => {
        debugger
        const postedData = {
            "criticism": "",
            "suggestion": "",
            "answer": commentAnswer,
            "id": commentId ? commentId : 47812
        };
        addAnswerComment(postedData).then(({ data }) => {
            debugger
            if (data.status) {
                toast.success('   پاسخ با موفقیت ثبت شد');
                setCommentAnswer("")
                setComment("")
            }
        })
    }



    return (
        <div className="row m-0">
            <div className=' mt-4 mb-4 alert alert-info mx-0'>
                <b>
                    <i className="fa fa-info mx-2 text-danger"></i>
                    وارد کردن
                    <span className='text-danger'> &nbsp;     نظرسنجی   &nbsp;</span>

                    و همچنین
                    <span className='text-danger'>  &nbsp;   شرکت کرده &nbsp;</span>
                    ،
                    <span className='text-danger'>&nbsp; الزامی &nbsp;</span>
                    است.
                </b>
            </div>


            {/*   <div className="col-md-2">
                <div className="form-group">
                    {guild ? <i className="fe fe-x clear-select-btn" onClick={e => setGuild(0)}></i> : ''}
                    <label>صنف</label>
                    <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="  همه موارد  " options={guilds} value={guilds.filter(b => b.value == guild)} onChange={e => setGuild(e.value)} />
                </div>


            </div> */}

            <div className="row m-0 my-4">
                <div className="col-md-2">
                    <div className="form-group">
                        {opinion ? <i className="fe fe-x clear-select-btn" onClick={e => setOpinion(0)}></i> : ''}
                        <label>نظرسنجی</label>
                        <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="  همه موارد " options={opinions} value={opinions.filter(b => b.value == opinion)} onChange={e => setOpinion(e.value)} />
                    </div>
                </div>
                <div className="col-md-2">
                    <div className="form-group">
                        {business ? <i className="fe fe-x clear-select-btn" onClick={e => setBusiness(0)}></i> : ''}
                        <label>کسب و کار</label>
                        <ReactSelect
                            noOptionsMessage={e => 'یافت نشد'}
                            defaultValue={{ label: "Standard", value: "standard" }}
                            placeholder="  همه موارد "
                            options={filteredBusinesses}
                            value={filteredBusinesses.filter(b => b.value == business)}
                            isDisabled={!opinion}
                            onChange={e => setBusiness(e.value)}
                        />
                    </div>
                </div>
                <div className="col-md-2 deskTopShow" style={{ position: "relative", zIndex: "10" }}>
                    <div className="form-group">
                        <label htmlFor="issueDate"> تاریخ شروع   </label><br />
                        {fromDate && <i class="fe fe-x clear-select-btn" onClick={() => setFromDate(null)} style={{left: 25}}></i>}
                        <DatePicker
                            name="p_fromdate"
                            required
                            locale="fa"
                            shouldHighlightWeekends
                            value={fromDate}
                            onChange={setFromDate}
                            className="form-control"
                            inputPlaceholder=' تاریخ  شروع   را انتخاب کنید ...'
                            calendarPopperPosition={"bottom"}
                        />
                    </div>
                </div>
                <div className="col-md-2" style={{ position: "relative", zIndex: "10" }}>
                    <div className="form-group">
                        <label htmlFor="p_todate"> تاریخ پایان   </label><br />
                        {toDate && <i class="fe fe-x clear-select-btn" onClick={() => setToDate(null)} style={{left: 25}}></i>}
                        <DatePicker
                            name="p_todate"
                            required
                            locale="fa"
                            calendarPopperPosition={"bottom"}
                            shouldHighlightWeekends
                            value={toDate}
                            onChange={setToDate}
                            className="form-control"
                            inputPlaceholder='  تاریخ پایان  را انتخاب کنید ...'
                        />
                    </div>
                </div>

                <div className="col-md-2">
                    <div className="form-group">
                        <label>شرکت زیر مجموعه</label>
                        <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="  همه موارد " options={branchs} isMulti={true} value={branchs.filter(item => branchId.includes(item.value))} onChange={e => setBranchId([...e.map(i => i.value)])} />
                    </div>
                </div>
                <div className="col-md-2">
                    <div className="form-group">
                        {(isParticipated === 0 || isParticipated === 1) ? <i className="fe fe-x clear-select-btn" onClick={e => setIsParticipated('')}></i> : ''}
                        <label>شرکت کرده </label>
                        <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="  همه موارد " options={[{ value: 0, label: 'خیر' }, { value: 1, label: 'بله' }]} value={[{ value: 0, label: 'خیر' }, { value: 1, label: 'بله' }].filter(b => b.value === isParticipated)} onChange={e => setIsParticipated(e.value)} />
                    </div>
                </div>
                {isParticipated !== 0 && <div className="col-md-2">
                    <div className="form-group">
                        {(hasComment === 2 || hasComment === 1) ? <i className="fe fe-x clear-select-btn" onClick={e => setHasComment('')}></i> : ''}
                        <label>نظر دارد </label>
                        <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="  همه موارد " options={[{ value: 2, label: 'خیر' }, { value: 1, label: 'بله' }]} value={[{ value: 2, label: 'خیر' }, { value: 1, label: 'بله' }].filter(b => b.value === hasComment)} onChange={e => setHasComment(e.value)} />
                    </div>
                </div>}

                <div className="col-md-2">
                    <div className="form-group">
                        <label>شماره همراه</label>
                        <InputMask mask="9999-9999999" className="form-control ltr-input" onChange={e => setMobile(e.target.value)} />
                    </div>
                </div>
                <div className="col-md-2">
                    <div className="form-group">
                        {provinceId ? <i className="fe fe-x clear-select-btn" onClick={e => {
                            setProvinceId(0)
                            setCityId(0)
                            setCities([])
                        }
                        }></i> : ''}

                        <label>استان</label>
                        <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" options={provinces} value={provinces.filter(item => item.value == provinceId)} onChange={e => setProvinceId(e.value)} />
                    </div>
                </div>
                <div className="col-md-2">
                    <div className="form-group">
                        {(cityId && provinceId) ? <i className="fe fe-x clear-select-btn" onClick={e => setCityId(0)}></i> : ''}
                        <label>شهر</label>
                        <ReactSelect noOptionsMessage={e => 'یافت نشد'} disabled={!provinces.length} placeholder="انتخاب کنید" isDisabled={!cities.length} options={cities} value={cities.filter(item => item.value == cityId)} onChange={e => setCityId(e.value)} />
                    </div>
                </div>

                <div className="py-2 col-md-3" style={{ marginTop: 22, textAlign: "right" }}>
                    {showItem && <> <button className="btn btn-primary" onClick={getReportsData} disabled={!opinion || (isParticipated !== 0 && isParticipated !== 1)}>جستجو</button>
                        {isAdvanced &&
                            <button className="btn btn-danger mx-2" onClick={resetAdvancedSearch}>حذف فیلتر</button>
                        }
                    </>
                    }
                </div>
            </div>

            {/* 
            <div className="col-md-1" style={{ marginTop: 31, textAlign: "center" }}>
                <button className="btn btn-primary" onClick={getReportsData}>جستجو</button>
            </div>

            {isAdvanced && <div className="col-md-1" style={{ marginTop: 31 }}>
                <button className="btn btn-danger btn-block" onClick={resetAdvancedSearch}>حذف فیلتر</button>
            </div>} */}


            {isLoading ?
                <div className="lds-facebook mt-4">
                    <div></div>
                    <div></div>
                    <div></div>
                </div > :

                <>
                    {rows.length ? <div className="row col-md-12 mt-3">
                        {comment ? <div className="col-12 borderR_ ">
                            <h5 class="title current mt-1 d-flex justify-content-between ">
                                <div>
                                    <i class="fa fa-hand-o-left"></i>
                                    <b>    ثبت پاسخ  </b>
                                    <br />
                                    <small class="text-danger ">
                                        <i class="fa fa-star mx-2"></i>
                                        با توجه به کامنت مطرح شده پاسخ خود را ثبت کنید.
                                    </small>
                                </div>
                            </h5>

                            <div className='row mx-auto' style={{ display: "flex", alignItems: "end" }}>

                                <div className="col-md-12 pr-0">
                                    <div className="form-group">
                                        <div className="alert alert-info alert-dismissible">
                                            <p className="mb-0 text-dark">{comment}</p>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 pr-0">
                                    <div className="form-group">
                                        <textarea value={commentAnswer} name={"commentAnswer"} onChange={(e) => setCommentAnswer(e.target.value)} type="text"
                                            className="form-control mt-0" />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group mb-0">
                                        <button className="btn btn-success px-4 btn-block"
                                            onClick={() => saveAnswer()}
                                        >ذخیره پاسخ  </button>
                                    </div>
                                </div>
                            </div>
                        </div> : ''}

                        <div className="table-responsive bg-white p-4" style={{ borderRadius: 7 }}>
                            <table className="table custom-table-style table-bordered table-hover mb4">
                                <thead className="table-primary text-center">
                                    <tr>
                                        <th>ردیف</th>
                                        <th>نام</th>
                                        <th>کد ملی</th>
                                        <th>صنف</th>
                                        <th>کسب و کار</th>
                                        <th>شماره همراه</th>
                                        <th>تاریخ ارسال پیامک</th>
                                        <th>تاریخ ثبت نظر</th>
                                        <th>مشاهده نظر</th>
                                    </tr>
                                </thead>
                                <tbody className="text-center">
                                    {rows.map((row, i) => (
                                        <tr>
                                            <td style={{ width: "1%", textAlign: "center" }}> {((currentPage - 1) * (pageItems === 0 ? 10 : pageItems)) + i + 1}  </td>
                                            <td>{row.full_name}</td>
                                            <td>{row.nationalcode}</td>
                                            <td>{row.guild_name}</td>
                                            <td>{row.business_name}</td>
                                            <td>{row.consumer_mobile}</td>
                                            <td>{row.register_date ? row.register_date.toString().slice(0, 4) + '/' + row.register_date.toString().slice(4, 6) + '/' + row.register_date.toString().slice(6, 8) : '-'}</td>
                                            <td dir="ltr">{row.answerdate ? row.answerdate.toString().slice(0, 4) + '/' + row.answerdate.toString().slice(4, 6) + '/' + row.answerdate.toString().slice(6, 8) + ' ' + row.answerdate.split(' ')[1] : '-'}</td>
                                            <td>{row.comments ? <button className="btn btn-info btn-icon" onClick={() => {
                                                setComment(row.comments)
                                                setCommentAnswer(row.commentAnswer)
                                                setCommentId(row?.id)
                                            }}><i className="fa fa-eye"></i></button> : '-'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <span>تعداد کل رکورد ها : {count}</span>
                            <div className="d-flex justify-content-between">

                                <Pagination changePage={changePage} currentPage={currentPage} pages={pages} prevPageClick={prevPage} nextPageClick={nextPage} lastPage={lastPage} />

                                <div className="form-group d-flex align-items-center  m-0  ">
                                    <label className='mx-2 mt-4' style={{ textWrap: "nowrap" }}>  تعداد نمایش
                                        در صفحه:  </label>
                                    <select className="form-control" onChange={e => setPageItems(e.target.value)}
                                        style={{ width: "25%" }}  >
                                        <option value="10">  10 </option>
                                        <option value="20">  20 </option>
                                        <option value="50">  50 </option>
                                        <option value="100">  100 </option>
                                    </select>
                                </div>

                            </div>
                            <button className="btn btn-success mt-4" onClick={downloadExcelFile}>دریافت خروجی اکسل</button>
                        </div>
                    </div> : isSearched ? <div className="col-md-12 mt-2"><div className="alert alert-primary"><p>داده ای جهت نمایش یافت نشد</p></div></div> : <div className="col-md-12 mt-2"><div className="alert alert-info"><p>جهت دریافت اطلاعات پس از اعمال فیلتر های مورد نظر بر روی جستجو کلیک کنید</p></div></div>
                    }
                </>
            }
        </div>
    );
}

export default Participated;
